var _excluded = ["parentId", "size"],
  _excluded2 = ["description", "href", "onClick", "text", "to"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Badge from "../../../basic/Badge/Badge.js";
import LinkText from "../../../type/LinkText.js";
import { getTableItemDescriptionSize } from "../helpers.js";
/* Data number display for table items */
var StyledNameContainer = styled.div.withConfig({
  componentId: "CL__sc-21jm3j-0"
})(["flex:1;"]);
export var StyledRouterLink = styled(Link).withConfig({
  componentId: "CL__sc-21jm3j-1"
})(["font-weight:var(--body-text-bold-font-weight);text-decoration:none !important;cursor:pointer;&:link,&:visited{font-weight:var(--body-text-bold-font-weight);color:var(--link-color);}&:hover{font-weight:var(--body-text-bold-font-weight);color:var(--link-color-hover);}&:active{font-weight:var(--body-text-bold-font-weight);color:var(--link-color-active);}"]);
export var ItemName = styled.h2.withConfig({
  componentId: "CL__sc-21jm3j-2"
})(["font:var(--body-text-", ");color:var(--text-color);display:block;margin:0;max-height:", ";text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden;a:focus{outline:none;}a:focus-visible{color:var(--link-color-hover);text-decoration:underline !important;}"], _ref => {
  var {
    size
  } = _ref;
  return size;
}, _ref2 => {
  var {
    size
  } = _ref2;
  return size === 'large' ? '3.75rem' : '3rem';
});
export var ItemTags = styled.div.withConfig({
  componentId: "CL__sc-21jm3j-3"
})(["display:flex;flex-wrap:wrap;gap:var(--spacing-1);padding:3px 0;"]);
export var ItemDescription = styled.span.withConfig({
  componentId: "CL__sc-21jm3j-4"
})(["font:", ";color:var(--text-color-dim);display:block;"], _ref3 => {
  var {
    size
  } = _ref3;
  return getTableItemDescriptionSize(size);
});
var TableItemName = _ref4 => {
  var {
      parentId,
      size = 'medium'
    } = _ref4,
    props = _objectWithoutProperties(_ref4, _excluded);
  var {
      description,
      href,
      onClick,
      text,
      to
    } = props,
    linkProps = _objectWithoutProperties(props, _excluded2);
  var {
    tags
  } = props;
  var useLink = href || onClick || to;

  // Render linked/non-linked name
  var renderNameLink = () => {
    if (to) {
      return /*#__PURE__*/React.createElement(StyledRouterLink, _extends({
        onClick: onClick,
        to: to
      }, linkProps), text);
    }
    return /*#__PURE__*/React.createElement(LinkText, _extends({
      href: href || '#',
      onClick: onClick,
      underline: false
    }, linkProps), text);
  };
  return /*#__PURE__*/React.createElement(StyledNameContainer, null, /*#__PURE__*/React.createElement(ItemName, {
    id: "".concat(parentId, "-name"),
    size: size
  }, useLink ? renderNameLink() : text), tags && /*#__PURE__*/React.createElement(ItemTags, null, tags.map(tag => {
    if (!tag) return;
    return /*#__PURE__*/React.createElement(Badge, {
      id: tag.id,
      rounded: true
    }, tag.name);
  })), description && /*#__PURE__*/React.createElement(ItemDescription, {
    size: size
  }, description));
};
export default TableItemName;